
import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import Slider from '@mui/material/Slider';
import Label from './Label.jsx';

export default function RangeInput(props) {
  const { slug, label, min, max, selectedValue, disabled } = props;

  const [value, setValue] = React.useState([]);

  React.useEffect(() => {
    setValue(selectedValue ?? []);
  }, [selectedValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeCommitted = (event, newValue) => {
    props.parentFunction(newValue, slug);
  };

  return (
    <ThemeProvider theme={backYouTheme}>
      <Label htmlForValue={"radio-input-" + slug} label={label}/>
      <div className="pt-1 px-3">
        <Slider
          getAriaLabel={() => label}
          value={typeof value != 'undefined' && value.length > 0 ? value : [min, max]}
          onChange={handleChange}
          onChangeCommitted={handleChangeCommitted}
          min={min}
          max={max}
          valueLabelDisplay="auto"
          disabled={disabled}
        />        
      </div>
    </ThemeProvider>
  );
}